<template>
  <div class="helper-text">
    <i class="el-icon-info"></i>
    <span class="ml-5">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>
